var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrossDownIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33639 23.725L5.3355 23.7242L0.460497 18.8256C0.0952938 18.4586 0.0966529 17.865 0.463684 17.4997C0.830669 17.1345 1.42425 17.1359 1.7895 17.5028L5.0625 20.7918V0.9375C5.0625 0.419719 5.48222 0 6 0C6.51778 0 6.9375 0.419719 6.9375 0.9375V20.7917L10.2105 17.5029C10.5757 17.1359 11.1693 17.1345 11.5363 17.4998C11.9034 17.865 11.9047 18.4587 11.5395 18.8256L6.6645 23.7242L6.66361 23.7251C6.29714 24.0923 5.70164 24.0911 5.33639 23.725Z",
    fill: "#FF7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrossDownIcon);
export default __webpack_public_path__ + "static/media/gross_down_icon.a68d1b0b1e42bfe06aa94c2e93b79657.svg";
export { ForwardRef as ReactComponent };